// extracted by mini-css-extract-plugin
export default {"wrapper":"TutorialContent_wrapper__xVk-A","checkboxAudio":"TutorialContent_checkboxAudio__viGv9"};